import { Form } from 'antd';
import { useEffect, useRef } from 'react';

export const useTagsChangedWarning = () => {
  const form = Form.useFormInstance();
  const watchedId = Form.useWatch('_id', form);
  const watchedTags = Form.useWatch('tags', form);

  const initialTagsRef = useRef<string[] | undefined>(undefined);

  const normalizeTags = (tags: unknown): string[] => {
    if (!Array.isArray(tags)) return [];
    return tags
      .map(tag => (typeof tag === 'string' ? tag : (tag as { _id?: string })?._id))
      .filter((v): v is string => Boolean(v))
      .sort();
  };

  useEffect(() => {
    initialTagsRef.current = undefined;
  }, [watchedId]);

  useEffect(() => {
    if (!watchedId) return;
    if (initialTagsRef.current !== undefined) return;

    const initial = form.getFieldValue('tags');
    initialTagsRef.current = normalizeTags(initial);
  }, [watchedId, watchedTags, form]);

  const currentTagsNormalized = normalizeTags(watchedTags);
  const initialTagsNormalized = initialTagsRef.current ?? [];

  const tagsChanged =
    Boolean(watchedId) &&
    initialTagsRef.current !== undefined &&
    (initialTagsNormalized.length !== currentTagsNormalized.length ||
      initialTagsNormalized.some((v, i) => v !== currentTagsNormalized[i]));

  return { tagsChanged };
};
